import React, { useEffect, useState } from "react";
import Webcam from "react-webcam";
import { base64ToFile } from "helpers/helpers";
import { toast } from "react-toastify";
var DetectRTC = require("detectrtc");

export default function UploadCamera({ name, setFieldValue, fileName }) {
   const [showCamera, setShowCamera] = useState(false);

   const videoConstraints = {
      width: 1280,
      height: 720,
      facingMode: "user",
      zIndex: 1,
      alingSelf: "center",
   };

   // fa load la functia de detectare a camerei
   useEffect(() => {
      DetectRTC.load(function () {
         if (DetectRTC.hasWebcam === false) {
            toast.error("Dispozitivul dvs. nu are camera. Va rugam sa folositi un dispozitiv cu camera daca doriti sa folositi aceasta optiune.");
         }
      });
   }, [showCamera]);
   return (
      <>
         {!showCamera ? (
            <div className="col-md-6 position-relative">
               <label htmlFor={name} className="cursor-pointer">
                  <img onClick={() => setShowCamera(true)} src={require("assets/images/photo-icon.png")} />
               </label>
               <div className="text-s">sau</div>
               <p className="text-up">Fotografiază documentul folosind camera dispozitivului</p>
            </div>
         ) : (
            <div className="col-md-6 position-relative fd-flex flex-column pb-4">
               {DetectRTC.isWebsiteHasWebcamPermissions ? (
                  <Webcam audio={false} height={"auto"} screenshotFormat="image/jpeg" width={250} videoConstraints={videoConstraints}>
                     {({ getScreenshot }) => (
                        <div className="row col-md-12 capture-buttons">
                           <button
                              className="capture-button col-6"
                              type="button"
                              onClick={() => {
                                 const imageSrc = getScreenshot({ width: 1280, height: 720 });
                                 const file = base64ToFile(imageSrc, fileName);
                                 setFieldValue(name, file);
                                 setShowCamera(false);
                              }}
                           >
                              Fa poza
                           </button>
                           <button className="capture-button col-6" onClick={() => setShowCamera(false)}>
                              Anuleaza
                           </button>
                        </div>
                     )}
                  </Webcam>
               ) : (
                  <div>
                     <p className="text-up">Nu ai permisiunea activata din browser pentru a folosi camera acestui dispozitiv.</p>
                     <button className="capture-button" onClick={() => setShowCamera(false)}>
                        Inchide
                     </button>
                  </div>
               )}
            </div>
         )}
      </>
   );
}
